module.exports = __webpack_public_path__ + "static/sassIcon-380e22e306f5f0e7ceb6077715651b76.png";